import React, {useState} from "react";
import Header from "./header";
import Footer from "./footer";
import FooterMini from "./footer-mini";
import CtaBlock from "./cta-block";
//import Scroll from "./scroll";

const Layout = ({
  children,
  showCta = true,
  showMenus = true,
  showFooterMenus = true,
  showHeader = true,
  showFooter = true,
  isMarketplace = false,
  dark = false,
  showMiniFooter = false,
  isFrontPage = false,
  HeaderComp = Header
  //isExperimentalPage = false,
}) => {

  const [openId, setOpenId] = useState(0);

  return (
    <div className={dark ? "dark" : ""}>
      <div className="dark:bg-[#010101]">
        {showHeader && (
          <HeaderComp
            showMenus={showMenus}
            isMarketplace={isMarketplace}
            dark={dark}
            isFrontPage={isFrontPage}
            openId={openId}
            setOpenId={setOpenId}
          />
        )}
        <main className={openId ? "lg:brightness-95 bg-[#1A1D210D]": "" }>{children}</main>
        {showCta && <CtaBlock />}
        {showFooter && <Footer showMenus={showFooterMenus} />}
        {showMiniFooter && <FooterMini />}
        {/* <Scroll showBelow={950} /> */}
      </div>
    </div>
  );
};

export const Layout3 = ({ children }) => {
  return (
    <>
      <main className="">{children}</main>
      {/* <Scroll showBelow={950} /> */}
    </>
  );
};

export default Layout;
